import React from "react";
import { Application } from "../../../model_gen/application";
import { Label } from "../../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import { PlusIcon } from "lucide-react";

const NONE_VALUE = "__none__";

export interface WorkflowApplicationSelectProps {
  label?: string;
  value: number | undefined;
  onChange: (val: number | undefined) => void;
  applications: Application[];
  onNewApplication: () => void;
  labelId?: string;
}

const WorkflowApplicationSelect: React.FC<WorkflowApplicationSelectProps> = ({
  label = "Application",
  value,
  onChange,
  applications,
  onNewApplication,
  labelId = "wf-application",
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={labelId}>{label}</Label>
      <Select
        value={value === undefined || value === null ? NONE_VALUE : String(value)}
        onValueChange={(val) => {
          if (val === "new_application") {
            onNewApplication();
          } else if (val === NONE_VALUE) {
            onChange(undefined);
          } else {
            onChange(val ? Number(val) : undefined);
          }
        }}
      >
        <SelectTrigger id={labelId}>
          <SelectValue placeholder="Select application (optional)" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE_VALUE}>None</SelectItem>
          {applications
            .filter((app) => app.id != null && !isNaN(app.id))
            .map((app) => (
              <SelectItem key={app.id} value={app.id!.toString()}>
                {app.application_name}
              </SelectItem>
            ))}
          <SelectItem value="new_application" className="border-t border-border mt-1 pt-2">
            <div className="flex items-center gap-2 text-maitai-green font-medium">
              <PlusIcon className="w-4 h-4" />
              Create New Application
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default WorkflowApplicationSelect;
